import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashboardsComponent} from './dashboards.component';
import {DxDashboardControlModule} from 'devexpress-dashboard-angular';
import {DevExtremeModule} from 'devextreme-angular';
import {DashboardsRoutingModule} from './dashboards-routing.module';
import {BiDashboardModule} from 'src/app/widgets/bi-dashboard/bi-dashboard.module';

@NgModule({
	declarations: [
		DashboardsComponent,
	],
	imports: [
		CommonModule,
		DashboardsRoutingModule,
		DxDashboardControlModule,
		DevExtremeModule,
		BiDashboardModule,
	],
})

export class DashboardsModule { }